import './scripts/common';
import {findAll, findIn, findAllIn, on, closest, addClass, removeClass} from './libs/@elements/dom-utils';
import {onFind} from "./libs/@elements/init-modules-in-scope";

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

// Todo: Add page specific JS here e.g:
import * as locationfinderMap from './scripts/locationfinder-map.js';
locationfinderMap.init();

import * as geoLocation from './scripts/geolocation.js';
geoLocation.init();

(function init(){
    onFind('.locationfinder__list-container', function(item){
        let gradient =  findIn('.js-locationfinder-gradient', item);
        on('scroll', function(){
            if (item.scrollTop + item.offsetHeight >= item.scrollHeight){
                removeClass('locationfinder__gradient', gradient);
            } else{
                addClass('locationfinder__gradient', gradient);
            }
        }, item);
    });
})();

import * as locationListTracking from './scripts/tracking/location-list-tracking.js';
locationListTracking.init();